import {hook} from '../../src/hook.js';

before(() => {
  hook.ready();
});
